import P2Regular from 'components/typography/P2Regular';
import { DeviceRow } from 'components/tables/data/device/types';

/**
 * Column for the device subtype name.
 */
export default function DeviceSubtypeNameColumn({ data: { deviceSubtype } }: { data: DeviceRow }) {
  return <P2Regular lineClamp={3}>{deviceSubtype.deviceTypeName}</P2Regular>;
}
